module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Other Works By James Carlos Blake"
    }
  }, [_c('p', {
    staticClass: "centerb"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_i",
      "title": "i"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii",
      "title": "ii"
    }
  }, [_vm._v("Other Works"), _c('br'), _vm._v("By James Carlos Blake")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Novels")]), _c('br'), _vm._v("The Ways of Wolfe"), _c('br'), _vm._v("The House of Wolfe"), _c('br'), _vm._v("The Rules of Wolfe"), _c('br'), _vm._v("Country of the Bad Wolfes"), _c('br'), _vm._v("The Killings of Stanley Ketchel"), _c('br'), _vm._v("Handsome Harry"), _c('br'), _vm._v("Under the Skin"), _c('br'), _vm._v("A World of Thieves"), _c('br'), _vm._v("Wildwood Boys"), _c('br'), _vm._v("Red Grass River"), _c('br'), _vm._v("In the Rogue Blood"), _c('br'), _vm._v("The Friends of Pancho Villa"), _c('br'), _vm._v("The Pistoleer")]), _vm._v(" "), _c('p', {
    staticClass: "centerbt"
  }, [_c('i', [_vm._v("Collection")]), _c('br'), _vm._v("Borderlands")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea4a530e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780802156969_Front1.vue
// module id = 57
// module chunks = 0